import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isOpen: false,
  payload: {
    rating: null,
  },
  ratings: [],
  activeRating: {},
};

const ratingSlice = createSlice({
  name: 'rating',
  initialState,
  reducers: {
    openRatingModal(state, _action) {
      state.isOpen = true;
    },

    closeRatingModal(state, _action) {
      state.isOpen = false;
    },

    setRatingPayload(state, action) {
      state.payload = action.payload;
    },

    clearRatingPayload(state) {
      state.payload = initialState.payload;
    },

    clearActiveRating(state) {
      state.activeRating = initialState.activeRating;
    },

    setRatings(state, action) {
      state.ratings = action.payload;
    },

    filterActiveRating(state) {
      state.activeRating = state.ratings[0];
    },

    updateRatings(state, action) {
      state.ratings = state.ratings.filter(
        (rating) => rating.id !== action.payload
      );
    },
  },
});

export const {
  openRatingModal,
  closeRatingModal,
  setRatings,
  filterActiveRating,
  updateRatings,
  setRatingPayload,
  clearRatingPayload,
  clearActiveRating,
} = ratingSlice.actions;

export default ratingSlice.reducer;
